import React from "react";
import { useGetJobRecommendationsQuery } from "@lib/store/slices/jobs";
import { JobListing } from "@lib/types/jobTypes";
import RecommendationList from "./RecommendationList";

function JobRecommendations({ job }: { job: JobListing }) {
  const { data: recommendations } = useGetJobRecommendationsQuery(job);

  return (
    <div className="w-full">
      {recommendations && (
        <>
          <RecommendationList
            title={`Mehr Jobs von ${job.company.name}`}
            jobs={recommendations.company}
            key={`${job.id}:company`}
          />
          <RecommendationList
            title="Ähnliche Jobs"
            jobs={recommendations.similar}
            key={`${job.id}:similar`}
          />
        </>
      )}
    </div>
  );
}

export default JobRecommendations;
